<div class="form-field-extended-fields" [hidden]="showJsonView" (mouseup)="formDataChangedDebounced($event)" (keyup)="formDataChangedDebounced($event)">
    <ng-container #dynamicform></ng-container>
</div>
<lib-json-view *ngIf="showJsonView && !hideConfigJSON" (dataChange)="jsonDataChangedDebounced($event)" [(data)]="configData"></lib-json-view>
<lib-json-view *ngIf="showJsonView && hideConfigJSON" [(data)]="configData"></lib-json-view>